import React, { useState, useEffect } from 'react';
import { useAlertPlus } from 'hooks';
import AlertModal from 'components/AlertModal';
import {
  getHonorariosEntidades,
} from '../../features/matriculates/matriculatesAPI';
import {
  HonorariosEntidades as HonorariosEntidadesType,
} from 'types/MatriculateRequest';

interface Props {
  titulosPagos: string[];
}

export default function HonorariosEntidades({ titulosPagos }: Props) {
  const [showAlert, message, alertCallback, alert] = useAlertPlus('');

  const [honorarios, setHonorarios] = useState<HonorariosEntidadesType[]>([]);

  useEffect(() => {
    getHonorariosEntidades(titulosPagos)
      .then(response => {
        setHonorarios(response);
      })
      .catch(() => {
        alert('No se puedieron obtener los honorarios de la solicitud');
      });
  }, []);

  const formatearImporte = (valor: number | string) => {
    return new Intl.NumberFormat('es-AR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(Number(valor));
  };

  return (
    <>
      <p>
        { titulosPagos.length === 1
          ? <><u>Pago a realizar para obtener el comprobante</u>{':'}</>
          : <><u>Pagos que deben realizarse de manera independiente para obtener un comprobante de cada uno</u>{':'}</>
        }
      </p>
      <ul>
        {honorarios?.map(honorario => {
          return (
            <li key={honorario.id}>
              {honorario.nombre_pago} de $ {formatearImporte(honorario.monto)}
              {
                honorario.cbu
                  ? ` al CBU ${honorario.cbu}.`
                  : <>
                      {' ('}
                      <a
                        href="https://portal.gba.gob.ar/seccion/organismo/3/tramite/10711/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        click aquí
                      </a>
                      {')'}
                    </>
              }
            </li>
          );
        })}
      </ul>
      <AlertModal
        isOpen={showAlert}
        message={message}
        onClose={alertCallback}
      />
    </>
  );
}
